module.exports = __webpack_public_path__ + "/bundle/asset/1-fa3087111620aba43929f24384f87f71.png";